<template>
    <table class="table w-full border">
        <thead>
            <tr>
                <th class="text-left">Order #</th>
                <th class="text-left">Order Date</th>
                <th class="text-left">Ship Date</th>
                <th class="text-left">Promo Code</th>
                <th class="text-right">Subtotal</th>
                <th class="text-right">Tax</th>
                <th class="text-right">Total</th>
                <th class="text-right">Discount</th>
                <th class="text-right">Total After Discount</th>
            </tr>
        </thead>
        <tbody>
            <tr v-for="data, index in data.orders" :key="index" class="hover:cursor-pointer" @click="openOrder(data.id)">
                <td class="text-left">{{ data.order_number }}</td>
                <td class="text-left">{{ formatTimestamp(data.order_date) }}</td>
                <td class="text-left">{{ formatTimestamp(data.ship_date) }}</td>
                <td class="text-left">{{ data.code }}</td>
                <td class="text-right">${{ formatNumber(data.subtotal + data.fee_for_delivery) }}</td>
                <td class="text-right">${{ formatNumber(data.tax) }}</td>
                <td class="text-right">${{ formatNumber(data.total) }}</td>
                <td class="text-right">${{ formatNumber(data.promo_code_amount) }}</td>
                <td class="text-right">${{ formatNumber(data.charged_total) }}</td>
            </tr>
        </tbody>
        <tfoot>
            <tr>
                <td colspan="3"></td>
                <td class="text-right font-bold">Totals:</td>
                <td class="text-right font-bold">${{ formatNumber(data.totals.subtotal) }}</td>
                <td class="text-right font-bold">${{ formatNumber(data.totals.tax) }}</td>
                <td class="text-right font-bold">${{ formatNumber(data.totals.total) }}</td>
                <td class="text-right font-bold">${{ formatNumber(data.totals.promo_code_amount) }}</td>
                <td class="text-right font-bold">${{ formatNumber(data.totals.charged_total) }}</td>
            </tr>
        </tfoot>
    </table>
</template>

<script>
import { DateTime } from "luxon";

export default {
    name: 'PromoCodes',

    props: ['data'],

    methods: {
        openOrder(index) {
            window.open(route('orders.show', index), '_blank')
        },
        formatTimestamp(timestamp) {
            return DateTime.fromSQL(timestamp).toFormat('MMM. d, yyyy');
        },
        formatNumber(number) {
            return Math.round(number * 100) / 100;
        },
    },
}
</script>